/* Component in IndexShot to edit an IndexShot */
import React, { useEffect, useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import styles from "../../styles/Indexes.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Upload from "../../assets/upload.png"
import Alert from "react-bootstrap/Alert"
import Asset from "../../components/Asset"

import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import { Image } from "react-bootstrap"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast"

const MAX_FILE_SIZE_MB = 5
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

const IndexShotEdit = ({ setShowEdit, shot, setIndexShots, id, ser_id }) => {
  const host = useHostName()
  const [errors, setErrors] = useState({})
  const [postData, setPostData] = useState({
    number: "",
    content: "",
    image: "",
  })

  const { number, content, image } = postData

  useEffect(() => {
    /* Function to set the postData state */
    const handleMount = async () => {
      const { number, content, image } = shot;
      setPostData({ number, content, image })
    }

    handleMount()
  }, [shot])

  const imageInput = useRef(null)

  const validateFileSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true
    }

    if (inputRef?.current) {
      inputRef.current.value = ""
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`)
    return false
  }

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
    console.log(event.target.value)
  }

  const handleChangeImage = (event) => {
    if (!event.target.files.length) {
      return
    }
    const file = event.target.files[0]
    if (!validateFileSize(file, imageInput)) {
      return
    }
    URL.revokeObjectURL(image)
    setPostData({
      ...postData,
      image: URL.createObjectURL(file),
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()

    formData.append("series_id", ser_id)
    formData.append("number", number)
    formData.append("content", content)
    if (imageInput.current.files[0]) {
      formData.append("image", imageInput.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const  {data}  = await axiosReq.put(`/indexshots/${id}/`, formData)

        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          const { number, content, image } = data
          setIndexShots((prevShots) => ({
            ...prevShots,
            results: prevShots.results.map((shot) => {
              return shot.id === id
                ? {
                  ...shot,
                  number: number,
                  content: content,
                  image: image,
                }
                : shot
            }),
          }))
          setShowEdit(false)
          toast.success(`IndexShot Updated`);
        }

      } else {
        const  data  = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/indexshots/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          const { number, content, image } = data?.data
          setIndexShots((prevShots) => ({
            ...prevShots,
            results: prevShots.results.map((shot) => {
              return shot.id === id
                ? {
                  ...shot,
                  number: number,
                  content: content,
                  image: image,
                }
                : shot
            }),
          }))
          setShowEdit(false)
          toast.success(`IndexShot Updated Successfully!`);
        }

      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const buttons = (
    <div className="text-center mt-3">    
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} mr-3`}
        onClick={() => setShowEdit(false)}
      >
        Cancel
      </Button>
      <Button 
      className={`${btnStyles.Button} ${btnStyles.Blue} ml-3`} 
      type="submit">
        Update
      </Button>
    </div>
  );


  const [contentType, setContentType] = useState(null);

  const isImageFile = (fileType) => {
    const acceptedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
    ];
    return acceptedImageTypes.includes(fileType);
  };
  // GET FILE TYPE IMAGE/PDF
  const getContentTypeWithGET = async (url) => {
    try {
      const res = await fetch(url, { method: "GET", cache: "no-store" });
      return res.headers.get("Content-Type");
    } catch (err) {
      console.error("Error fetching content type:", err);
      return null;
    }
  };

  useEffect(() => {
    if (image) {
      getContentTypeWithGET(image).then(((res) => {
        setContentType(res)
      }));
    }
  }, [image]);
  return (
    <div className= {`text-center mt-2 pb-2 ${styles.Back}`} >
    <h5 className={`text-center mb-0 py-0 ${styles.SubTitle }`}
             style={{ textTransform: 'uppercase'}}>Edit Shot {number} </h5>
        <Form className="mt-0 mx-0 px-0" onSubmit={handleSubmit}>
          <Row className="mt-2">
          <Col xs={{span: 6, offset: 3}} className="d-flex justify-content-center" >
          <Form.Group controlId="number" className={`${styles.Width2} text-center`}  >
                  <Form.Label className={`pb-0 mb-0 ${styles.BoldScene} `} >Number</Form.Label>
                  <Form.Control 
                  className={styles.Input}
                  type="text"
                  name="number"
                  value={number}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.number?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
          </Col>
          </Row>
          <Row className="mt-2">
        <Col xs={12} className="p-0 d-flex justify-content-center">
            <Form.Group controlId="content" className={`${styles.Width2} `} >
            <Form.Label className={`pb-0 mb-0 ${styles.BoldScene}`} >Content</Form.Label>
            <Form.Control 
            type="text"
            className={styles.InputScene}
            as="textarea"
            name="content"
            rows={1}
            value={content}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.content?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
            {message}
        </Alert>
        ))}
            </Col> 
          </Row>
          <Row>
            <Col xs={12} className="mt-2 p-0 d-flex justify-content-center">
              <Container
                className={`${appStyles.Content2} ${styles.Container} 
          d-flex flex-column justify-content-center`}
              >
                <Form.Group className="text-center p-0 m-0">
                  {image ? (
                    <>
                      {shot?.image && contentType && (
                        <>
                          {isImageFile(contentType) ? (
                            <figure>
                              <Image
                                width="70%"
                                height="120px"
                                style={{ borderRadius: 8, border: "none" }}
                                src={image}
                                alt="shot"
                                className={`${appStyles.iframe} rounded`}
                              />
                            </figure>
                          ) : contentType === "application/pdf" ? (
                            <iframe
                              src={image}
                              title="pdf"
                              width="50%"
                              height="100px"
                              style={{ borderRadius: 8, border: "none" }}
                            />
                          ) : (
                            <p>Unsupported file type: {contentType}</p>
                          )}
                        </>)}
                      <div>
                        <Form.Label
                          className={`mt-3 ${btnStyles.Button} ${btnStyles.GreyDark}`}
                          htmlFor="image-upload"
                        >
                          Change the Image
                        </Form.Label>
                      </div>
                    </>
                  ) : (
                    <Form.Label
                      className="d-flex justify-content-center"
                      htmlFor="image-upload"
                    >
                      <Asset src={Upload} message="Upload Image or PDF" />
                    </Form.Label>
                  )}

                  <Form.Control
                    type="file"
                    id="image-upload"
                    accept="image/*,application/pdf"
                    onChange={handleChangeImage}
                    ref={imageInput}
                  />
                </Form.Group>
                {errors?.image?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Container>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className={` my-0`}>{buttons} </div>
            </Col>
          </Row>
        </Form>
    </div>
  )
}

export default IndexShotEdit
